export enum BannerTypeEnum {
  DEFAULT= 'DEFAULT',
  BOOKING_ARRIVAL_SOON = 'BOOKING_ARRIVAL_SOON',
  BOOKING_ARRIVAL_NOW = 'BOOKING_ARRIVAL_NOW',
  BOOKING_ARRIVAL_AFTER = 'BOOKING_ARRIVAL_AFTER'
}
